var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { FilterConflictBanner, GameFilterModal, GameFilterModalHeader, GameFilterModalInner, GameFilterModalSection, } from "../styles";
import Loader from "../../../Loader";
import leftArrowIcon from "../../../../assets/img/games/leftArrowIcon.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { cancelFiltering, clearGames, clearOrderedGames, getFilterProviders, getFilterTypes, getOrderedGames, handleSelectFilterOption, hideFilterConflict, searchGames, setIsTopGames, } from "../../../../actions/games/creators";
var messages = defineMessages({
    filters: {
        id: "games.filters",
        defaultMessage: "Фильтры",
    },
    providers: {
        id: "games.providers",
        defaultMessage: "Провайдеры",
    },
    types: {
        id: "games.types",
        defaultMessage: "Типы",
    },
    show: {
        id: "games.show",
        defaultMessage: "Показать",
    },
    clear: {
        id: "games.clear",
        defaultMessage: "Очистить",
    },
    uknownError: {
        id: "games.uknown_error",
        defaultMessage: "Что-то пошло не так!",
    },
    filterConflict: {
        id: "games.filter_conflict",
        defaultMessage: "Можно выбрать только один фильтр: провайдер или тип",
    },
});
var FILTER_CONFLICT_AUTOHIDE_MS = 4000;
var GamesFilterModal = /** @class */ (function (_super) {
    __extends(GamesFilterModal, _super);
    function GamesFilterModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isTop: _this.props.isTop,
            shouldSearchGames: false,
        };
        _this.onHandleSelectChange = function (option, fieldName) {
            _this.props.handleSelectFilterOptionAction(option, fieldName);
        };
        _this.formatFilterOptions = function (option) {
            return Array.from(option)
                .map(function (item) { return item[0]; })
                .join(",");
        };
        _this.searchGame = function () {
            _this.props.clearGamesAction();
            _this.setState({ shouldSearchGames: true });
        };
        _this.getBack = function () { return _this.props.handleCloseModal(); };
        _this.clearSearching = function () {
            _this.props.cancelFilteringAction();
            _this.props.handleCloseModal();
            _this.props.goToLobbyGames();
            if (!_this.props.location || _this.props.location.pathname !== "/games") {
                _this.props.history.push("/games");
            }
        };
        _this.handleCloseConflict = function () {
            if (_this.conflictHideTimer) {
                clearTimeout(_this.conflictHideTimer);
                _this.conflictHideTimer = null;
            }
            _this.props.hideFilterConflictAction();
        };
        _this.getStyleOfItems = function (isActive) {
            var style = {
                background: "rgb(119 119 119 / 56%)",
                padding: "10px 20px",
                color: "white",
                cursor: "pointer",
            };
            if (_this.props.darkTheme) {
                if (isActive) {
                    return __assign(__assign({}, style), { color: "rgb(0 0 0 / 70%)", background: "#fff" });
                }
                else {
                    return __assign(__assign({}, style), { color: "rgb(0 0 0 / 70%)", background: "rgb(255 255 255 / 49%)" });
                }
            }
            else {
                if (isActive) {
                    return __assign(__assign({}, style), { color: "white", background: "#777777" });
                }
                else {
                    return __assign(__assign({}, style), { background: "rgb(119 119 119 / 56%)" });
                }
            }
        };
        return _this;
    }
    GamesFilterModal.prototype.componentDidMount = function () {
        if (!this.props.providers)
            this.props.getFilterProvidersAction();
        if (!this.props.types)
            this.props.getFilterTypesAction();
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
    };
    GamesFilterModal.prototype.componentWillUnmount = function () {
        document.body.style.position = '';
        document.body.style.width = '';
        if (this.conflictHideTimer) {
            clearTimeout(this.conflictHideTimer);
            this.conflictHideTimer = null;
        }
        this.props.handleCloseModal();
    };
    GamesFilterModal.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, selectedTypes = _a.selectedTypes, selectedProviders = _a.selectedProviders, user = _a.user, limit = _a.limit, offset = _a.offset, filterConflict = _a.filterConflict;
        if (this.state.shouldSearchGames) {
            var types = this.formatFilterOptions(selectedTypes);
            var providers = this.formatFilterOptions(selectedProviders);
            var typesCount = selectedTypes.size;
            var providersCount = selectedProviders.size;
            this.setState({ shouldSearchGames: false });
            this.props.setIsTopGamesAction(this.state.isTop);
            if (!this.state.isTop && typesCount === 1 && providersCount === 0) {
                var id = Array.from(selectedTypes.keys())[0];
                this.props.handleCloseModal();
                this.props.history.push("/games/types/".concat(id));
                return;
            }
            if (!this.state.isTop && providersCount === 1 && typesCount === 0) {
                var option = Array.from(selectedProviders.values())[0];
                this.props.handleCloseModal();
                this.props.history.push("/games/providers/".concat(encodeURIComponent(option.Name)));
                return;
            }
            if (!this.state.isTop && (typesCount > 1 || providersCount > 1)) {
                this.props.clearOrderedGamesAction();
                this.props.getOrderedGamesAction({
                    types: types,
                    providers: providers,
                    gamblerId: user.gamblerId,
                    language: this.props.langId,
                    sortType: this.props.providerSortType,
                });
                this.props.goToSearchedGames();
                this.props.handleCloseModal();
                if (!this.props.location || this.props.location.pathname !== "/games") {
                    this.props.history.push("/games");
                }
                return;
            }
            this.props.clearGamesAction();
            this.props.searchGamesAction({
                name: "",
                types: types,
                providers: providers,
                gamblerId: user.gamblerId,
                isTop: this.state.isTop,
                limit: limit,
                offset: offset,
            });
            this.props.goToSearchedGames();
            this.props.handleCloseModal();
        }
        if (filterConflict && !prevProps.filterConflict) {
            if (this.conflictHideTimer)
                clearTimeout(this.conflictHideTimer);
            this.conflictHideTimer = setTimeout(function () {
                _this.props.hideFilterConflictAction();
                _this.conflictHideTimer = null;
            }, FILTER_CONFLICT_AUTOHIDE_MS);
        }
    };
    GamesFilterModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, types = _a.types, isLoading = _a.isLoading, error = _a.error, handleCloseModal = _a.handleCloseModal, selectedTypes = _a.selectedTypes, selectedProviders = _a.selectedProviders, darkTheme = _a.darkTheme, filterConflict = _a.filterConflict, intl = _a.intl;
        if (error)
            return (_jsx(GameFilterModal, __assign({ onClick: handleCloseModal }, { children: _jsx(GameFilterModalSection, __assign({ onClick: function (e) { return e.stopPropagation(); }, style: { background: darkTheme && "rgb(119, 119, 119)" } }, { children: _jsx("h3", __assign({ style: { fontSize: "20px", color: darkTheme && "white" } }, { children: this.props.intl.formatMessage(messages.uknownError) })) })) })));
        return (_jsxs(GameFilterModal, { children: [isLoading && _jsx(Loader, {}), _jsxs(GameFilterModalSection, __assign({ onClick: function (e) { return e.stopPropagation(); }, style: { background: darkTheme && "rgb(119, 119, 119)" } }, { children: [_jsxs(GameFilterModalHeader, { children: [_jsx("img", { width: 25, src: leftArrowIcon, alt: "arrow-icon", onClick: this.getBack }), _jsx("h3", __assign({ style: { fontSize: "20px", color: darkTheme && "white" } }, { children: this.props.intl.formatMessage(messages.filters) }))] }), filterConflict && (_jsxs(FilterConflictBanner, __assign({ darkTheme: darkTheme, role: "alert", "aria-live": "polite" }, { children: [_jsx("span", __assign({ className: "filter-conflict__text" }, { children: intl.formatMessage(messages.filterConflict) })), _jsx("button", __assign({ type: "button", className: "filter-conflict__close", onClick: this.handleCloseConflict, "aria-label": "close" }, { children: "\u00D7" }))] }))), _jsxs(GameFilterModalInner, { children: [_jsx("h3", __assign({ style: { fontSize: "18px", color: darkTheme && "white" } }, { children: this.props.intl.formatMessage(messages.providers) })), _jsx("div", __assign({ style: {
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "10px",
                                        marginTop: "15px",
                                    } }, { children: providers &&
                                        providers.map(function (pvdr) {
                                            return (_jsx("div", __assign({ onClick: function () {
                                                    return _this.onHandleSelectChange(pvdr, "selectedProviders");
                                                }, style: _this.getStyleOfItems(selectedProviders.has(pvdr.Id)) }, { children: _jsx("span", { children: pvdr.Name }) }), pvdr.Id));
                                        }) })), _jsx("div", { style: { margin: "20px 0" } }), _jsx("h3", __assign({ style: { fontSize: "18px", color: darkTheme && "white" } }, { children: this.props.intl.formatMessage(messages.types) })), _jsx("div", __assign({ style: {
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "10px",
                                        marginTop: "15px",
                                    } }, { children: types &&
                                        types.map(function (type) {
                                            return (_jsx("div", __assign({ onClick: function () {
                                                    return _this.onHandleSelectChange(type, "selectedTypes");
                                                }, style: _this.getStyleOfItems(selectedTypes.has(type.Id)) }, { children: _jsx("span", { children: type.Name }) }), type.Id));
                                        }) }))] }), _jsxs("div", __assign({ style: {
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                marginTop: "20px",
                            } }, { children: [_jsx("button", __assign({ onClick: this.clearSearching, style: {
                                        width: "100%",
                                        padding: "10px 20px",
                                        border: "1px solid gray",
                                        color: this.props.darkTheme && "rgb(0 0 0 / 70%)",
                                    } }, { children: this.props.intl.formatMessage(messages.clear) })), _jsx("button", __assign({ onClick: this.searchGame, style: {
                                        width: "100%",
                                        border: "none",
                                        padding: "10px 20px",
                                        backgroundColor: "#269062",
                                        color: "white",
                                    } }, { children: this.props.intl.formatMessage(messages.show) }))] }))] }))] }));
    };
    return GamesFilterModal;
}(Component));
var mapStateToProps = function (state) {
    var _a = state.games.games, data = _a.data, isLoading = _a.isLoading, isTop = _a.isTop;
    var _b = state.games.gamesFilter, providers = _b.providers, types = _b.types, error = _b.error, selectedTypes = _b.selectedTypes, selectedProviders = _b.selectedProviders, providerSortType = _b.providerSortType, filterConflict = _b.filterConflict;
    return {
        limit: data.Limit,
        offset: data.Offset,
        providers: providers,
        types: types,
        isLoading: isLoading,
        isTop: isTop,
        error: error,
        selectedTypes: selectedTypes,
        selectedProviders: selectedProviders,
        providerSortType: providerSortType,
        filterConflict: filterConflict,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    getFilterProvidersAction: getFilterProviders,
    getFilterTypesAction: getFilterTypes,
    handleSelectFilterOptionAction: handleSelectFilterOption,
    hideFilterConflictAction: hideFilterConflict,
    cancelFilteringAction: cancelFiltering,
    searchGamesAction: searchGames,
    clearGamesAction: clearGames,
    setIsTopGamesAction: setIsTopGames,
    getOrderedGamesAction: getOrderedGames,
    clearOrderedGamesAction: clearOrderedGames,
};
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(GamesFilterModal)));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesFilter/GamesFilterModal.jsx